import _defineProperty from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.number.is-finite.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.entries.js";
import router from '@/router';
import store from '@/store';

// 同儕比較門檻
var PEER_MIN_COUNT = 3; // 中位數比較法所需的最少台數（2 台的中位數等於平均，兩台必然對稱分佈）
var PEER_CAPACITY_TOLERANCE = 0.1; // 容量相差在此比例內視為同一組（同組即視為屋頂條件相近）
var PEER_NOISE_GATE = 0.5; // 中位數低於此值 (kWh/kWp) 視為清晨/陰天雜訊，整段不判
var PEER_SUNUP_GATE = 0.1; // 同儕基準達此值 (kWh/kWp) 即確認太陽已出來，零發電機組才判定
var PEER_DEVIATION_LIMIT = 30; // 偏離度門檻 (%)，以芳生螺絲二期實測校準

// 完全沒發電：今日累計與瞬時功率同時為 0。
// acp 必須明確為 0 才算——缺值時不判，避免資料不全時誤報；
// 啟動較晚的機組雖然 E_today 暫時為 0，acp 已經 > 0，不會落入此條件。
var isDead = function isDead(peer) {
  return peer.norm === 0 && peer.acp === 0;
};
var median = function median(nums) {
  var sorted = _toConsumableArray(nums).sort(function (a, b) {
    return a - b;
  });
  var mid = Math.floor(sorted.length / 2);
  return sorted.length % 2 === 1 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2;
};

/**
 * 依裝置容量把候選機組切成數組，容量相差在 tolerance 內者視為同一組。
 *
 * 一個 factoryId 可能涵蓋多棟建物或多期屋頂（如「BM7倉庫&BM10倉庫(一期)」），
 * 各屋頂朝向與傾角不同，標準化後仍有穩定的系統性落差。容量分組是屋頂分組的
 * 代理(proxy)指標——同一批安裝的機組容量通常相同。
 *
 * @param {Array<Object>} candidates 具 cap 欄位的候選機組
 * @param {number} tolerance 相鄰容量的最大相對差距
 * @returns {Array<Array<Object>>} 分組結果
 */
var groupByCapacity = function groupByCapacity(candidates, tolerance) {
  var sorted = _toConsumableArray(candidates).sort(function (a, b) {
    return a.cap - b.cap;
  });
  var groups = [];
  var current = [];
  sorted.forEach(function (peer) {
    var prev = current[current.length - 1];
    if (!prev || (peer.cap - prev.cap) / prev.cap <= tolerance) {
      current.push(peer);
    } else {
      groups.push(current);
      current = [peer];
    }
  });
  if (current.length) groups.push(current);
  return groups;
};

// basis 供 hover 說明判斷依據用，故一併帶上比較基準、同儕組成與門檻
var flagOutlier = function flagOutlier(row, deviation, mode, basis) {
  row['連線狀態'] = 2;
  row['發電偏離度 (%)'] = deviation;
  row._peerMode = mode;
  row._peerBasis = basis;
  row._cellVariants['今日發電量 (kWh)'] = 'warning';
};

// 3 台以上：與組內中位數比較，可指名哪一台離群
var markByMedian = function markByMedian(tableData, group) {
  var baseline = median(group.map(function (p) {
    return p.norm;
  }));

  // group 已依 cap 由小到大排序
  var groupBasis = {
    ref: baseline,
    count: group.length,
    capMin: group[0].cap,
    capMax: group[group.length - 1].cap,
    limit: PEER_DEVIATION_LIMIT
  };
  group.forEach(function (peer) {
    // 完全沒發電與日照強弱無關，只要同儕確實在發電就成立，
    // 故不受雜訊閘門保護——閘門擋的是「偏低不可信」，不是「毫無產出」
    if (isDead(peer) && baseline >= PEER_SUNUP_GATE) {
      flagOutlier(tableData[peer.index], -100, 'dead', _objectSpread(_objectSpread({}, groupBasis), {}, {
        self: 0
      }));
      return;
    }
    if (baseline < PEER_NOISE_GATE) return;
    var deviation = (peer.norm - baseline) / baseline * 100;
    if (Math.abs(deviation) <= PEER_DEVIATION_LIMIT) return;
    flagOutlier(tableData[peer.index], Math.round(deviation), 'median', _objectSpread(_objectSpread({}, groupBasis), {}, {
      self: peer.norm
    }));
  });
};

// 恰好 2 台：兩台互比。無第三方可投票，故只能同時標記兩台，無法歸屬
var markByPair = function markByPair(tableData, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    a = _ref2[0],
    b = _ref2[1];
  var pairBasis = function pairBasis(self, other) {
    return {
      self: self.norm,
      ref: other.norm,
      count: 2,
      capMin: Math.min(a.cap, b.cap),
      capMax: Math.max(a.cap, b.cap),
      limit: PEER_DEVIATION_LIMIT
    };
  };

  // 一台完全沒發電、另一台確實在發電 → 死機可指名，不受雜訊閘門保護
  var dead = [a, b].find(isDead);
  var alive = dead && (dead === a ? b : a);
  if (dead && alive.norm >= PEER_SUNUP_GATE) {
    flagOutlier(tableData[dead.index], -100, 'dead', pairBasis(dead, alive));
    return;
  }
  if (median([a.norm, b.norm]) < PEER_NOISE_GATE) return;
  var low = Math.min(a.norm, b.norm);
  var high = Math.max(a.norm, b.norm);
  // 走到這裡仍為 0 的情況是兩台皆 0，或 acp 缺值無法確認死機，落差無意義
  if (!(low > 0)) return;
  if ((high - low) / low * 100 <= PEER_DEVIATION_LIMIT) return;
  [[a, b], [b, a]].forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      self = _ref4[0],
      other = _ref4[1];
    var deviation = (self.norm - other.norm) / other.norm * 100;
    flagOutlier(tableData[self.index], Math.round(deviation), 'pair', pairBasis(self, other));
  });
};

/**
 * 同儕比較：以標準化日發電量 (E_today / capacity, kWh/kWp) 與同容量機組相比，
 * 偏離超過門檻者標為發電離群（連線狀態 2 + 該格 warning 黃底 + 記錄偏離度）。
 *
 * 同一案場各台 INV 容量不必然相同，故必須先除以各自 capacity 才能比較，
 * 並依容量分組後再比——跨屋頂比較會產生穩定的誤報。
 * 斷線機台回傳舊值或 0，納入基準會污染中位數，因此排除在候選之外。
 * 組內僅 1 台時無同儕可比，略過。
 *
 * @param {Array<Object>} tableData 已組好的表格列，會被就地修改
 * @param {Object} item factories_min 的 detail 物件
 */
var markGenerationOutliers = function markGenerationOutliers(tableData, item) {
  var candidates = [];
  tableData.forEach(function (row, i) {
    var _item$capacity$i, _item$capacity, _store$state$capacity, _item$E_today, _item$acp;
    // 斷線優先：斷線是事實、離群是推論，斷線機台不判離群也不進同儕池
    if (row['連線狀態'] !== 0) return;

    // WS 推播的 detail 可能缺 capacity，備援(fallback)讀 store
    var cap = (_item$capacity$i = (_item$capacity = item.capacity) === null || _item$capacity === void 0 ? void 0 : _item$capacity[i]) !== null && _item$capacity$i !== void 0 ? _item$capacity$i : (_store$state$capacity = store.state.capacity) === null || _store$state$capacity === void 0 ? void 0 : _store$state$capacity[i];
    var eToday = (_item$E_today = item.E_today) === null || _item$E_today === void 0 ? void 0 : _item$E_today[i];
    if (!(cap > 0) || !Number.isFinite(eToday)) return;
    candidates.push({
      index: i,
      cap: cap,
      norm: eToday / cap,
      acp: (_item$acp = item.acp) === null || _item$acp === void 0 ? void 0 : _item$acp[i]
    });
  });
  groupByCapacity(candidates, PEER_CAPACITY_TOLERANCE).forEach(function (group) {
    if (group.length >= PEER_MIN_COUNT) markByMedian(tableData, group);else if (group.length === 2) markByPair(tableData, group);
    // 僅 1 台：無同儕可比，略過
  });
};
var tableRender = function tableRender(item) {
  var _store$state$factoryI;
  var tableData = [];
  var invLength = parseInt(router.history.current.query.invLen);
  var pvLength = parseInt(router.history.current.query.pvLen);
  var factory = router.history.current.query.siteName || '';
  var isDemo = factory.includes('展示案場 ');
  if (isDemo) {
    var demoIndex = factory.split(' ')[1] - 1;
    factory = store.state.factoryInfo[demoIndex].factory;
  }
  var invSN = ((_store$state$factoryI = store.state.factoryInfo.find(function (x) {
    return x.factory === factory;
  })) === null || _store$state$factoryI === void 0 ? void 0 : _store$state$factoryI.invSN) || [];
  var V = {};
  if (invLength) {
    for (var i = 0; i < invLength; i++) {
      var _item$State, _item$AC_kWh, _item$E_today2, _item$dcp, _item$acp2, _item$Eff, _item$freq, _item$Rc, _item$Sc, _item$Tc, _item$ErrorMessage, _item$ErrorMessage$in;
      if (item.Vrs || item.Vst || item.Vrt) {
        var _item$Vrs, _item$Vst, _item$Vrt;
        V.ab = (_item$Vrs = item.Vrs) === null || _item$Vrs === void 0 ? void 0 : _item$Vrs[i];
        V.bc = (_item$Vst = item.Vst) === null || _item$Vst === void 0 ? void 0 : _item$Vst[i];
        V.ca = (_item$Vrt = item.Vrt) === null || _item$Vrt === void 0 ? void 0 : _item$Vrt[i];
      } else if (item.Vrn || item.Vsn || item.Vtn) {
        var _item$Vrn, _item$Vsn, _item$Vtn;
        V.ab = (_item$Vrn = item.Vrn) === null || _item$Vrn === void 0 ? void 0 : _item$Vrn[i];
        V.bc = (_item$Vsn = item.Vsn) === null || _item$Vsn === void 0 ? void 0 : _item$Vsn[i];
        V.ca = (_item$Vtn = item.Vtn) === null || _item$Vtn === void 0 ? void 0 : _item$Vtn[i];
      }
      var data = {
        'INV 名稱': "INV".concat(i + 1).concat(invSN[i] ? " - ".concat(invSN[i]) : ''),
        'INV 狀態': (_item$State = item.State) === null || _item$State === void 0 ? void 0 : _item$State[i],
        '累積發電量 (kWh)': (_item$AC_kWh = item.AC_kWh) === null || _item$AC_kWh === void 0 ? void 0 : _item$AC_kWh[i],
        '今日發電量 (kWh)': (_item$E_today2 = item.E_today) === null || _item$E_today2 === void 0 ? void 0 : _item$E_today2[i],
        '直流發電功率 (kW)': (_item$dcp = item.dcp) === null || _item$dcp === void 0 ? void 0 : _item$dcp[i],
        '交流發電功率 (kW)': (_item$acp2 = item.acp) === null || _item$acp2 === void 0 ? void 0 : _item$acp2[i],
        'INV 效率 (%)': (_item$Eff = item.Eff) !== null && _item$Eff !== void 0 && _item$Eff[i] ? item.Eff[i] * 100 : null,
        '頻率 (Hz)': (_item$freq = item.freq) === null || _item$freq === void 0 ? void 0 : _item$freq[i],
        'Vab 電壓 (V)': V.ab,
        'Vbc 電壓 (V)': V.bc,
        'Vca 電壓 (V)': V.ca,
        'A相電流 (A)': (_item$Rc = item.Rc) === null || _item$Rc === void 0 ? void 0 : _item$Rc[i],
        'B相電流 (A)': (_item$Sc = item.Sc) === null || _item$Sc === void 0 ? void 0 : _item$Sc[i],
        'C相電流 (A)': (_item$Tc = item.Tc) === null || _item$Tc === void 0 ? void 0 : _item$Tc[i],
        '連線狀態': DateTime.fromSeconds(Number(item.SYSTIME)).diff(DateTime.local(), 'minutes').minutes <= -30 ? 1 : (_item$ErrorMessage = item.ErrorMessage) === null || _item$ErrorMessage === void 0 ? void 0 : (_item$ErrorMessage$in = _item$ErrorMessage.inv) === null || _item$ErrorMessage$in === void 0 ? void 0 : _item$ErrorMessage$in[i],
        '發電偏離度 (%)': null,
        '_invIndex': i,
        '_cellVariants': {}
        // _cellVariants: { '累積發電量 (kWh)': 'danger', '今日發電量 (kWh)': 'danger' }
      };
      // if (item.mppt_a && item.mppt_v) {
      for (var j = 0; j < pvLength; j++) {
        var a = "PV".concat(j + 1, "\u96FB\u6D41 (A)");
        var v = "PV".concat(j + 1, "\u96FB\u58D3 (V)");
        if (item.mppt_v || item.mppt_a) {
          var _item$mppt_v, _item$mppt_v$i, _item$mppt_a, _item$mppt_a$i, _Obj;
          var Obj = (_Obj = {}, _defineProperty(_Obj, v, (_item$mppt_v = item.mppt_v) === null || _item$mppt_v === void 0 ? void 0 : (_item$mppt_v$i = _item$mppt_v[i]) === null || _item$mppt_v$i === void 0 ? void 0 : _item$mppt_v$i[j]), _defineProperty(_Obj, a, (_item$mppt_a = item.mppt_a) === null || _item$mppt_a === void 0 ? void 0 : (_item$mppt_a$i = _item$mppt_a[i]) === null || _item$mppt_a$i === void 0 ? void 0 : _item$mppt_a$i[j]), _Obj);
          Object.assign(data, Obj);
        } else if (item.pv_v || item.pv_a) {
          var _item$pv_v, _item$pv_v$i, _item$pv_a, _item$pv_a$i, _Obj3;
          var _Obj2 = (_Obj3 = {}, _defineProperty(_Obj3, v, (_item$pv_v = item.pv_v) === null || _item$pv_v === void 0 ? void 0 : (_item$pv_v$i = _item$pv_v[i]) === null || _item$pv_v$i === void 0 ? void 0 : _item$pv_v$i[j]), _defineProperty(_Obj3, a, (_item$pv_a = item.pv_a) === null || _item$pv_a === void 0 ? void 0 : (_item$pv_a$i = _item$pv_a[i]) === null || _item$pv_a$i === void 0 ? void 0 : _item$pv_a$i[j]), _Obj3);
          Object.assign(data, _Obj2);
        }
      }
      tableData.push(data);
    }
  }
  markGenerationOutliers(tableData, item);
  tableData.forEach(function (x) {
    if (x['交流發電功率 (kW)'] > 0) {
      var arr = [];
      for (var _i = 0, _Object$entries = Object.entries(x); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        if (value === 0 && key !== '連線狀態' && key !== 'INV 狀態') {
          arr.push(key);
        }
      }
      arr.forEach(function (y) {
        x._cellVariants[y] = 'danger';
      });
    }
  });
  return tableData;
};
export default tableRender;